import React from 'react';
import styled from 'styled-components';
import { Target, Shield } from 'lucide-react';

const ConfidenceBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  border: 2px solid #a78bfa;
  border-radius: 12px;
  padding: 10px 18px;
  margin: 16px 0;
  direction: rtl;
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.15);

  .badge-icon {
    width: 22px;
    height: 22px;
    color: #7c3aed;
  }

  .badge-label {
    font-size: 14px;
    font-weight: 600;
    color: #5b21b6;
  }

  .badge-value {
    font-size: 16px;
    font-weight: 800;
    padding: 4px 12px;
    border-radius: 8px;
    background: ${props => {
      const value = props.value;
      if (value >= 80) return 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)';
      if (value >= 60) return 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)';
      return 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)';
    }};
    color: ${props => {
      const value = props.value;
      if (value >= 80) return '#166534';
      if (value >= 60) return '#b45309';
      return '#dc2626';
    }};
  }
`;

const ConfidenceUnavailable = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 8px 14px;
  margin: 16px 0;
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
  direction: rtl;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ConfidenceScoring = ({ confidenceScoring }) => {
  // HIDDEN from end users: this badge showed `columns_definitions_quality` = the % of SQL columns
  // that have a description in the pack (an INTERNAL schema-documentation metric). Labelled
  // "التغطية" (coverage) it was misread as data coverage, and was noisily 0% for legitimate
  // queries (aliases / aggregates / MV columns have no description). Not actionable for a business
  // user, so we don't display it. The value is still computed upstream if ever needed.
  return null;

  // eslint-disable-next-line no-unreachable
  if (!confidenceScoring) {
    return null;
  }

  // Check if all values are "unavailable"
  const isUnavailable = Object.values(confidenceScoring).every(value => value === "unavailable");

  if (isUnavailable) {
    return (
      <ConfidenceUnavailable>
        <Shield />
        تقييم الثقة غير متاح
      </ConfidenceUnavailable>
    );
  }

  const value = confidenceScoring.columns_definitions_quality;
  const displayValue = typeof value === 'number' ? `${value.toFixed(0)}%` : 'غير متاح';
  const numericValue = typeof value === 'number' ? value : 0;

  return (
    <ConfidenceBadge value={numericValue}>
      <Target className="badge-icon" />
      <span className="badge-label">التغطية:</span>
      <span className="badge-value">{displayValue}</span>
    </ConfidenceBadge>
  );
};

export default ConfidenceScoring;
